import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { mdiArrowRight } from '@mdi/js'
import Icon from '@mdi/react'
import { FormattedMessage } from 'react-intl'
import { UseTableRowProps } from 'react-table'

import theme from 'theme_'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { Mark, Marking } from 'components/Mark'
import type { JobWithHomeType } from 'features/domains/types'
import { createHomeUrl, getSubscriptionInfo } from 'features/domains/utils'

import { DomainsHomeSubscriptionPlan } from '..'
import { jobsTablesMessages } from '../DomainJobsHomesTable/messages'
import { JOBS_HOMES_HEADERS } from '../DomainJobsHomes/consts'
import DomainHomeSubscriptionEndDate from '../DomainHomeSubscriptionEndDate'
import {
  MobileJobTableItemInfoRow,
  MobileJobTableItemInfoTitle,
  MobileJobTableItemHomeName,
  MobileJobTableItemPlanWrapper,
  MobileJobTableItemTitleWrapper,
  MobileJobTableItemHeader,
  MobileJobTableItemMain,
  MobileJobTableItemMainInner,
  MobileJobTableItemVersion,
  MobileJobTableItem,
  MobileJobTableItemInfoRight,
} from './styles'
import HostIcon from 'components/HostIcon'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { useAppSelector } from 'app/hooks'

interface MobileJobHomeComponentProps {
  values: Record<JOBS_HOMES_HEADERS, any>
  original: UseTableRowProps<JobWithHomeType>['original']
}

function MobileJobHomeComponent(props: MobileJobHomeComponentProps) {
  const history = useHistory()
  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  const { name, softwareVersion, status, updated } = props.values
  const subscriptionInfo = getSubscriptionInfo(props.original)

  const handleHomeItemClick = useCallback(() => {
    const homeId = props.original.homes[0].id
    const homeUrl = createHomeUrl(currentRootId, homeId)

    history.push(homeUrl)
  }, [currentRootId, history, props.original.homes])

  return (
    <MobileJobTableItem tabIndex={0} onClick={handleHomeItemClick}>
      <MobileJobTableItemHeader>
        {props.original.name}
        <Icon
          path={mdiArrowRight}
          size={1}
          color={theme.colors.horizonOrange}
        />
      </MobileJobTableItemHeader>
      <MobileJobTableItemMain>
        <MobileJobTableItemMainInner>
          <div style={{ marginRight: '8px' }}>
            <Mark
              marking={(status as boolean) ? Marking.Check : Marking.Error}
            />
          </div>
          <HostIcon size={24} home={props.original.homes[0]} />
          <MobileJobTableItemTitleWrapper>
            <MobileJobTableItemHomeName>{name}</MobileJobTableItemHomeName>
          </MobileJobTableItemTitleWrapper>
        </MobileJobTableItemMainInner>
      </MobileJobTableItemMain>
      <MobileJobTableItemInfoRow>
        <MobileJobTableItemInfoTitle>
          <FormattedMessage {...jobsTablesMessages.updated} />
        </MobileJobTableItemInfoTitle>
        <MobileJobTableItemInfoRight>
          <IntlFormattedDate date={updated} withTime />
        </MobileJobTableItemInfoRight>
      </MobileJobTableItemInfoRow>
      <MobileJobTableItemInfoRow>
        <MobileJobTableItemInfoTitle>
          <FormattedMessage {...jobsTablesMessages.softwareVersion} />
        </MobileJobTableItemInfoTitle>
        <MobileJobTableItemInfoRight>
          <MobileJobTableItemVersion>
            {softwareVersion}
          </MobileJobTableItemVersion>
        </MobileJobTableItemInfoRight>
      </MobileJobTableItemInfoRow>
      <MobileJobTableItemPlanWrapper>
        <DomainsHomeSubscriptionPlan subscriptionInfo={subscriptionInfo} />
        <MobileJobTableItemInfoRight>
          {subscriptionInfo ? (
            <DomainHomeSubscriptionEndDate
              withTime
              subscriptionInfo={subscriptionInfo}
            />
          ) : (
            '-'
          )}
        </MobileJobTableItemInfoRight>
      </MobileJobTableItemPlanWrapper>
    </MobileJobTableItem>
  )
}

export default MobileJobHomeComponent
